import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75bb3f46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = { class: "tabs-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "workplace" }

import { TabData } from './types';
import { ref, nextTick, watch } from 'vue';
import Tab from './Tab.vue';

interface Emits {
  (type: 'update:currentTab', e: string): void;
}
interface Props {
  tabs: TabData[],
  vertical?: boolean;
  currentTab?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabs: null,
    vertical: { type: Boolean },
    currentTab: null
  },
  emits: ["update:currentTab"],
  setup(__props: any, { emit }: { emit: ({
  (type: 'update:currentTab', e: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tabs: TabData[],
  vertical?: boolean;
  currentTab?: string;
}





const activeTabName = ref<string>(props.currentTab || props.tabs[0].name);
async function chooseTab(tabName: string) {
  if (activeTabName.value !== tabName) {
    activeTabName.value = tabName;
    emit('update:currentTab', tabName);
    await nextTick();
    window.dispatchEvent(new Event('resize'));
  }
}
watch(() => props.currentTab, (value) => {
  if (value) {
    chooseTab(value);
  }
});

const errorsByTab = ref<Record<string, boolean>>(props.tabs.reduce((res, current) => {
  return {
    ...res,
    [current.name]: false,
  };
}, {}));
function updateTabError(name: string, error: boolean) {
  errorsByTab.value = {
    ...errorsByTab.value,
    [name]: error,
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tabs-wrapper", { vertical: __props.vertical }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: tab.name,
            onClick: ($event: any) => (chooseTab(tab.name)),
            class: _normalizeClass(["tab", {
          active: tab.name === activeTabName.value,
          'has-error': errorsByTab.value[tab.name] || false,
        }])
          }, [
            _renderSlot(_ctx.$slots, tab.name, {
              title: tab.title
            }, () => [
              _createTextVNode(_toDisplayString(tab.title), 1)
            ])
          ], 10, _hoisted_3)), [
            [_vShow, !tab.hide]
          ])
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "tabs-end")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
        return _withDirectives((_openBlock(), _createBlock(Tab, {
          key: tab.name,
          onHasErrorUpdated: ($event: any) => (updateTabError(tab.name, $event)),
          class: "active-tab"
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, `tab-${tab.name}`)
          ]),
          _: 2
        }, 1032, ["onHasErrorUpdated"])), [
          [_vShow, tab.name === activeTabName.value]
        ])
      }), 128))
    ])
  ], 2))
}
}

})